<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Set GPIO Output" icon="⚙" color="#ca8a04">
        <label>Output pin</label>
        <input type="number" min="0" max="39"
            :value="props.data.outputPin ?? 0"
            @input="update('outputPin', parseInt($event.target.value) || 0)" />

        <label>State</label>
        <select :value="props.data.state !== false ? '1' : '0'" @change="update('state', $event.target.value === '1')">
            <option value="1">High (1)</option>
            <option value="0">Low (0)</option>
        </select>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
</script>
